import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';
import { setSuggestReviewer } from 'Redux/AuthorRedux/SubmitmanuscriptRedux/AuthorArticleRedux/AuthorArticleRedux';

const initialState = {
  Register: {},
  notification: {},
  listRegistor: {},
  editorList: {},
  reviewerdropdown: {},
  reviewerList: {},
  editorDropdown: {},
  update: {},
  deleteitem: {},
  AssignedArticles: {},
  reviewerAssignedManuscript: {},
  AuthorManuscript: {},
  suggestedreviewers: {}
};

const RegisterSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    setRegister(state, action) {
      state.Register = action.payload;
    },
    setToast(state, action) {
      state.notification = action.payload;
    },
    setListRigistor(state, action) {
      state.listRegistor = action.payload;
    },
    setEditorList(state, action) {
      state.editorList = action.payload;
    },
    setReviewerDropdown(state, action) {
      state.reviewerdropdown = action.payload;
    },
    setReviewerList(state, action) {
      state.reviewerList = action.payload;
    },
    setUpdate(state, action) {
      state.update = action.payload;
    },
    setDeleteItem(state, action) {
      state.delete = action.payload;
    },
    seteditorDropdown(state, action) {
      state.editorDropdown = action.payload;
    },
    setAssignedArticles(state, action) {
      state.AssignedArticles = action.payload;
    },
    setReviewerAssignedManuscript(state, action) {
      state.reviewerAssignedManuscript = action.payload;
    },
    setAuthorManuscript(state, action) {
      state.AuthorManuscript = action.payload;
    },
    setSuggestedReviewers(state, action) {
      state.suggestedreviewers = action.payload
    }
  },
});

export const RegisterAPi = (values, tokendata) => async (dispatch) => {
  console.log(values, "kjshfj");
  const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/register`, values,
    {
      headers: {
        "authorization": ` Bearer ${tokendata}`
      }
    }
  )
    .then((res) => {
      console.log(res, "fsdfff")
      // dispatch(setRegister(res?.data))
      dispatch(setToast({
        status: true, message: res?.data?.message
      }))

    })
    .catch((err) => {
      console.log(err?.response, "wddss");
      dispatch(setToast({
        status: false, message: err?.response?.data?.message
      }))
    })

}
export const AssignNewEditorApi = (values, tokendata) => async (dispatch) => {
  console.log(values, "kjshfj");
  const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/ats/manuscriptEditorAssign`, values,
    {
      headers: {
        "authorization": ` Bearer ${tokendata}`
      }
    }
  )
    .then((res) => {
      console.log(res, "fsdfff")
      // dispatch(setRegister(res?.data))
      dispatch(setToast({
        status: true, message: res?.data?.message
      }))

    })
    .catch((err) => {
      console.log(err?.response, "wddss");
      dispatch(setToast({
        status: false, message: err?.response?.data?.message
      }))
    })

}
export const RigisterListApi = (tokendata, page, limit, search) => async (dispatch) => {

  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/userList?page=${page}&limit=${limit}&search=${search}&user_type=author`, {
    headers: {
      "authorization": ` Bearer ${tokendata}`
    }
  })
    .then((res) => {
      console.log(res, "ssddss");
      dispatch(setListRigistor(res?.data?.data));

    })
    .catch((err) => {
      console.log(err?.response, "errror");

    })
}

export const AssignedEditorListApi = (tokendata, page, limit, search) => async (dispatch) => {

  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/manuscript/assignEditorList?page=${page}&limit=${limit}&search=${search}`, {
    headers: {
      "authorization": ` Bearer ${tokendata}`
    }
  })
    .then((res) => {
      console.log(res, "ssddss");
      dispatch(setListRigistor(res?.data?.data));

    })
    .catch((err) => {
      console.log(err?.response, "errror");

    })
}
export const AssignedArticlesListApi = (tokendata, editorid) => async (dispatch) => {

  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/editor/articleModalData/${editorid}`, {
    headers: {
      "authorization": ` Bearer ${tokendata}`
    }
  })
    .then((res) => {
      console.log(res, "ssddss");
      dispatch(setAssignedArticles(res?.data?.data));

    })
    .catch((err) => {
      console.log(err?.response, "errror");

    })
}

export const ListEditorApi = (tokendata, page, limit, search) => async (dispatch) => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/userList?page=${page}&limit=${limit}&search=${search}&user_type=editor`, {
    headers: {
      "Authorization": `Bearer ${tokendata}`
    }
  })
    .then((res) => {
      console.log(res, "kfksk");
      dispatch(setEditorList(res?.data?.data))

    })
    .catch((err) => {
      console.log(err?.response, "error");

    })
}

export const AddReviewerDropdown = () => async (dispatch) => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/classficationList?page=&limit=`)
    .then((res) => {
      console.log(res, 'rfeferf');
      dispatch(setReviewerDropdown(res?.data?.data));
    })
    .catch((err) => {
      console.log(err?.response, "errrror");

    })
}

export const EditorDropdownApi = (tokendata) => async (dispatch) => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/articleDropdown`, {
    headers: {
      'Authorization': `Bearer ${tokendata}`
    }
  })
    .then((res) => {
      console.log(res, 'dhfbvhdfv');
      dispatch(seteditorDropdown(res?.data));
    })
    .catch((err) => {
      console.log(err?.response, 'sbdvhdv');
    })
}

export const ListReviewerApi = (tokendata, page, limit, search) => async (dispatch) => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/userList?page=${page}&limit=${limit}&search=${search}&user_type=reviewer`, {
    headers: {
      "Authorization": `Bearer ${tokendata}`
    }
  })
    .then((res) => {
      console.log(res, "jfifi");
      dispatch(setReviewerList(res?.data?.data))

    })
    .catch((err) => {
      console.log(err?.response, "error");

    })
}

export const AssignedReviewermanuscriptApi = (tokendata, uuid) => async (dispatch) => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/manuscript/assignReviwersList/${uuid}`, {
    headers: {
      "Authorization": `Bearer ${tokendata}`
    }
  })
    .then((res) => {
      console.log(res, "jfifi");
      dispatch(setReviewerAssignedManuscript(res?.data?.data))

    })
    .catch((err) => {
      console.log(err?.response, "error");

    })
}

export const AuthorManuscriptApi = (tokendata, uuid) => async (dispatch) => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/publisher/authorSubmitedManuscript/${uuid}`, {
    headers: {
      "Authorization": `Bearer ${tokendata}`
    }
  })
    .then((res) => {
      console.log(res, "jfifi");
      dispatch(setAuthorManuscript(res?.data?.data))

    })
    .catch((err) => {
      console.log(err?.response, "error");

    })
}

export const UpdateApi = (tokendata, updatePayload, edituuid) => async (dispatch) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/user/update/${edituuid}`, updatePayload, {
    headers: {
      "Authorization": `Bearer ${tokendata}`
    }
  })
    .then((res) => {
      console.log(res, "udpdateres");
      dispatch(setUpdate(res?.data));
      dispatch(setToast({
        status: true, message: res?.data?.message
      }))

    })
    .catch((err) => {
      console.log(err?.response, "errijndf")
      dispatch(setToast({
        status: false, message: err?.response?.data?.message
      }))
    })
}

export const deleteApi = (deleteuuid, tokendata) => async (dispatch) => {
  const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/ats/user/delete/${deleteuuid}`,
    {
      headers: {
        "Authorization": `Bearer ${tokendata}`
      }
    }
  )
    .then((res) => {
      console.log(res, "lkkdelete");
      // dispatch(setDeleteItem(res.data))
      dispatch(setToast({
        status: true, message: res?.data?.message
      }))
    })
    .catch((err) => {
      console.log(err?.response, "errresf888");
      dispatch(setToast({
        status: false, message: err?.response?.data?.message
      }))

    })
}
export const suggestedReviewersApi = (tokendata,page,limit,search) => async (dispatch) => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/suggestedReviewerList?page=${page}&limit=${limit}&search=${search}`,
    {
      headers: {
        "Authorization": `Bearer ${tokendata}`
      }
    }
  )
    .then((res) => {
      console.log(res, "suggestrev");
      dispatch(setSuggestedReviewers(res?.data?.data))

    })
    .catch((err) => {
      console.log(err?.response, "error");

    })
}



export const { setRegister, setToast, setListRigistor, setEditorList, setAuthorManuscript, setReviewerDropdown, setReviewerAssignedManuscript, seteditorDropdown, setReviewerList, setUpdate, setDeleteItem, setAssignedArticles,setSuggestedReviewers } = RegisterSlice.actions;
const RegisterReducer = RegisterSlice.reducer;

export default RegisterReducer;
